import React, { FC } from 'react';
import classes from '../asset/css/InitialLoading/index.module.css';
import { useLogging } from '../hooks/useLogging'; 

export const InitialLoading: FC = () => {

  useLogging('InitialLoading');

  const isAddSubscriptionButton = Boolean(window.location.href.match('?path=/subscription/add'));

  return (
     isAddSubscriptionButton ? (
       <button className={classes.addButton} disabled={true}>
         読み込み中...
       </button>
     ) : (
       <div className={classes.loading}>
         読み込み中です。少々お待ちください。
       </div>
     )
  )
};
